// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";
import * as CountryConstants$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/constants/CountryConstants.mjs";

function getHeaders(param) {
  return {
          "X-Country": CountryConstants$PorterinUtils.uae,
          "X-Currency": CountryConstants$PorterinUtils.ae,
          "X-TimeZone": "Asia/Dubai"
        };
}

var validateBoundariesPath = "pnm/geos/validate_boundaries";

var orderInterestPath = "pnm/interest/record";

var shiftReqBasicDetailsPath = "pnm/sr/record_basic_details";

var shiftReqLocationDetailsPath = "pnm/sr/record_location_details";

function getBoundaryValidatorUrl(param) {
  return Config$PorterinUtils.getPnmIntUrl(undefined) + validateBoundariesPath;
}

function getOrderInterestUrl(param) {
  return Config$PorterinUtils.getPnmIntUrl(undefined) + orderInterestPath;
}

function getShiftReqBasicDetailsUrl(param) {
  return Config$PorterinUtils.getPnmIntUrl(undefined) + shiftReqBasicDetailsPath;
}

function getShiftReqLocationDetailsUrl(param) {
  return Config$PorterinUtils.getPnmIntUrl(undefined) + shiftReqLocationDetailsPath;
}

export {
  getHeaders ,
  validateBoundariesPath ,
  orderInterestPath ,
  shiftReqBasicDetailsPath ,
  shiftReqLocationDetailsPath ,
  getBoundaryValidatorUrl ,
  getOrderInterestUrl ,
  getShiftReqBasicDetailsUrl ,
  getShiftReqLocationDetailsUrl ,
}
/* Config-PorterinUtils Not a pure module */
